import { createActions } from 'redux-actions';

export const { handleTemplate, clearTemplate, handlePdf, handleEditing } = createActions({
    handleTemplate: (template) => template,
    clearTemplate: () => ({}),
    handlePdf: (pdf) => pdf,
    handleEditing: (editing) => editing,
});
